/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Recentbuildstitle2Inputs */

const id_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build terbaru`)
};

const ms_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binaan terkini`)
};

const da_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste builds`)
};

const de_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Builds`)
};

const en_us2_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent builds`)
};

const es_es2_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilaciones recientes`)
};

const es_mx2_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilaciones recientes`)
};

const fil_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga kamakailang build`)
};

const fr_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilations récentes`)
};

const it_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build recenti`)
};

const hu_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legutóbbi build-ek`)
};

const nl_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recente builds`)
};

const no_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nylige builds`)
};

const pl_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnie kompilacje`)
};

const pt_br2_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Builds recentes`)
};

const pt_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilações recentes`)
};

const ro_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compilări recente`)
};

const fi_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeisimmät koontiversiot`)
};

const sv_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste byggen`)
};

const vi_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản dựng gần đây`)
};

const tr_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son yapılar`)
};

const cs_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nedávná sestavení`)
};

const bg_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скорошни компилации`)
};

const ru_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние сборки`)
};

const uk_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні збірки`)
};

const ar_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البنيات الأخيرة`)
};

const hi_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाल के बिल्ड`)
};

const th_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บิลด์ล่าสุด`)
};

const ja_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近のビルド`)
};

const zh_cn2_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近构建版本`)
};

const zh_hant1_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近建置版本`)
};

const ko_sandboxes_recentbuildstitle2 = /** @type {(inputs: Sandboxes_Recentbuildstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최근 빌드`)
};

/**
* | output |
* | --- |
* | "Recent builds" |
*
* @param {Sandboxes_Recentbuildstitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_recentbuildstitle2 = /** @type {((inputs?: Sandboxes_Recentbuildstitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Recentbuildstitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_recentbuildstitle2(inputs)
	if (locale === "ms") return ms_sandboxes_recentbuildstitle2(inputs)
	if (locale === "da") return da_sandboxes_recentbuildstitle2(inputs)
	if (locale === "de") return de_sandboxes_recentbuildstitle2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_recentbuildstitle2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_recentbuildstitle2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_recentbuildstitle2(inputs)
	if (locale === "fil") return fil_sandboxes_recentbuildstitle2(inputs)
	if (locale === "fr") return fr_sandboxes_recentbuildstitle2(inputs)
	if (locale === "it") return it_sandboxes_recentbuildstitle2(inputs)
	if (locale === "hu") return hu_sandboxes_recentbuildstitle2(inputs)
	if (locale === "nl") return nl_sandboxes_recentbuildstitle2(inputs)
	if (locale === "no") return no_sandboxes_recentbuildstitle2(inputs)
	if (locale === "pl") return pl_sandboxes_recentbuildstitle2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_recentbuildstitle2(inputs)
	if (locale === "pt") return pt_sandboxes_recentbuildstitle2(inputs)
	if (locale === "ro") return ro_sandboxes_recentbuildstitle2(inputs)
	if (locale === "fi") return fi_sandboxes_recentbuildstitle2(inputs)
	if (locale === "sv") return sv_sandboxes_recentbuildstitle2(inputs)
	if (locale === "vi") return vi_sandboxes_recentbuildstitle2(inputs)
	if (locale === "tr") return tr_sandboxes_recentbuildstitle2(inputs)
	if (locale === "cs") return cs_sandboxes_recentbuildstitle2(inputs)
	if (locale === "bg") return bg_sandboxes_recentbuildstitle2(inputs)
	if (locale === "ru") return ru_sandboxes_recentbuildstitle2(inputs)
	if (locale === "uk") return uk_sandboxes_recentbuildstitle2(inputs)
	if (locale === "ar") return ar_sandboxes_recentbuildstitle2(inputs)
	if (locale === "hi") return hi_sandboxes_recentbuildstitle2(inputs)
	if (locale === "th") return th_sandboxes_recentbuildstitle2(inputs)
	if (locale === "ja") return ja_sandboxes_recentbuildstitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_recentbuildstitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_recentbuildstitle2(inputs)
	return ko_sandboxes_recentbuildstitle2(inputs)
});
export { sandboxes_recentbuildstitle2 as "sandboxes.recentBuildsTitle" }